import React, {Fragment} from 'react';
import {connect} from "react-redux";

import {setContractsView} from "./contractsActions";
import {deleteContracts} from "./contractsAsyncActions";
import {CONTRACTS_VIEWS} from "./contractsReducer";
import ContractsList from "./ContractsList";
import {setQuestionPopupState} from "../../actions/A_Popups";

const Contracts = (props) => {

  const {deleteContracts, setContractsView, setQuestionPopupState, contractsList} = props;

  const uploadClick = () => {
    setContractsView(CONTRACTS_VIEWS.upload);
  }

  const deleteButtonDisabled = !contractsList.some(cont => cont.selected);

  const deleteSelectedClick = () => {
    if (deleteButtonDisabled) {
      return
    }
    setQuestionPopupState({
      showPopup: true,
      className: "ui-popup--shadow-bottom",
      questionMessage: "Are you sure you want to delete selected contracts?",
      yesClick: deleteContracts
    })
  }

  return (
    <Fragment>
      {/*<div className="jb-filters__selections">*/}
      <div className="flex">
        <div className="flex-item"></div>
        <div className="flex-item flex-item--60">
          <button className="ui-button3 ui-button3--white jb-filters__selections-button" onClick={uploadClick}>
            + Upload Files
          </button>
          <button className="ui-button3 ui-button3--white jb-filters__selections-button"
                  disabled={deleteButtonDisabled}
                  onClick={deleteSelectedClick}>
            Delete Selected
          </button>
        </div>
      </div>
      <ContractsList/>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {contractsView, contractsList} = store.contractsState;
  return {
    contractsView,
    contractsList,
  }
};

const mapDispatchToProps = {
  setContractsView,
  setQuestionPopupState,
  deleteContracts,
};

export default connect(mapStateToProps, mapDispatchToProps)(Contracts)
